import React, { useEffect } from 'react'
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  Button,
  makeStyles,
  Divider,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { useForm, Controller } from 'react-hook-form'

import { useDispatch, useSelector } from 'react-redux'

import { Creators as FunctionActions } from '~/store/ducks/function'
import { Creators as FunctionsActions } from '~/store/ducks/functions'
import OverlayLoading from '~/components/OverlayLoading'
import { useMobileScreen } from '~/helpers/useMediaQuery'

import styles from './style'

const useStyles = makeStyles(styles)

const functionSelector = ({ functionDuck }) => functionDuck.data
const loadingSelector = ({ functionDuck }) => functionDuck.loading

const DialogFunctions = ({ open, onClose, id }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const functionData = useSelector(functionSelector)
  const loading = useSelector(loadingSelector)
  const isEdit = !!id
  const isMobileScreen = useMobileScreen()

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    if (isEdit) {
      dispatch(FunctionActions.getFunctionRequest(id))
    } else {
      reset({ name: '' })
    }
  }, [isEdit])

  const reloadFunctions = () => {
    dispatch(FunctionsActions.getFunctionsRequest())
  }

  const onSubmit = (data) => {
    if (isEdit) {
      // update -> PUT
      dispatch(
        FunctionActions.updateFunctionRequest(id, data, () =>
          reloadFunctions(),
        ),
      )
    } else {
      // create -> POST
      dispatch(
        FunctionActions.addFunctionRequest(data, () => reloadFunctions()),
      )
    }
    onClose()
  }

  useEffect(() => {
    if (isEdit) {
      reset(functionData)
    }
  }, [isEdit, functionData])

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      fullScreen={isMobileScreen}
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">
          {isEdit ? 'Editar ' : 'Adicionar '}
          função
        </Typography>
      </DialogTitle>
      <Divider className={classes.divider} />

      {!isEdit && (
        <>
          <Grid container className={classes.subtitleWrapper}>
            <Grid item xs={12}>
              <Typography variant="h5">Nova Função</Typography>
            </Grid>
          </Grid>
          <Divider className={classes.dividerBottom} />
        </>
      )}
      <DialogContent className={classes.dialogContent}>
        {loading && <OverlayLoading />}
        {!loading && (
          <form onSubmit={handleSubmit(onSubmit)} id="formFunction">
            <Grid container>
              <Grid item xs={12}>
                <Controller
                  name="name"
                  control={control}
                  defaultValue=""
                  render={({ field: { onChange, value }, field }) => (
                    <TextField
                      variant="outlined"
                      autoFocus
                      label="Nome"
                      type="text"
                      onChange={onChange}
                      value={value}
                      error={!!errors.name}
                      helperText={!!errors.name && 'Campo obrigatório'}
                      fullWidth
                      {...field}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </DialogContent>
      <Divider className={classes.divider} />
      <DialogActions className={classes.buttonForm}>
        <Button onClick={onClose} variant="contained">
          CANCELAR
        </Button>
        <Button
          color="primary"
          type="submit"
          form="formFunction"
          variant="contained"
        >
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DialogFunctions.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number,
}

DialogFunctions.defaultProps = {
  id: null,
}

export default DialogFunctions
